// Approximate mouth shapes from the written response. Timing is spread over the
// actual audio duration; no microphone or audio-signal analysis is involved.
export function buildVisemeTimeline(text, duration) {
  const symbols = [...text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()]
  const units = symbols.map(char => {
    if ('aeiou'.includes(char)) return { viseme: char, weight: 1 }
    if (/\s/.test(char)) return { viseme: null, weight: 0.65 }
    if (/[.,!?;:]/.test(char)) return { viseme: null, weight: 1.5 }
    return { viseme: null, weight: 0.45 }
  })
  const total = units.reduce((sum, unit) => sum + unit.weight, 0) || 1
  let cursor = 0
  return units.map(unit => {
    const start = cursor / total * duration
    cursor += unit.weight
    return { start, end: cursor / total * duration, viseme: unit.viseme }
  })
}

export function visemeAt(timeline, time) {
  const unit = timeline.find(item => time >= item.start && time < item.end)
  return unit?.viseme || null
}
